export enum CustomFieldType {
    Dropdown = 'Dropdown',
    Checkbox = 'Checkbox',
    Text = 'Textfield',
    MultiLineText = 'MultiLineText'
}
